'use client';

import Image from 'next/image';
import { useState, useEffect } from 'react';
import { createClient } from '@/lib/supabase/client';

export default function HeroBranding() {
  const [appName, setAppName] = useState('copterstories');

  useEffect(() => {
    const supabase = createClient();
    supabase?.from('settings')?.select('value')?.eq('key', 'app_name')?.single()?.then(({ data }) => {
        if (data && typeof data?.value === 'string') {
          setAppName(data?.value);
        }
      });
  }, []);

  // Render app name with "copter" in white and "stories" in red
  const renderAppName = (name: string) => {
    const lower = name.toLowerCase();
    if (lower === 'copterstories') {
      return (
        <>
          <span className="text-white">copter</span>
          <span style={{ color: '#a40e10' }}>stories</span>
        </>
      );
    }
    // Fallback: split in half
    const half = Math.ceil(name.length / 2);
    return (
      <>
        <span className="text-white">{name.slice(0, half)}</span>
        <span style={{ color: '#a40e10' }}>{name.slice(half)}</span>
      </>
    );
  };

  return (
    <div className="text-center mb-10">
      {/* Logo */}
      <div className="inline-flex flex-col items-center gap-4 mb-6">
        <div className="relative w-24 h-24 flex items-center justify-center">
          <Image
            src="/assets/images/IMG_6391-removebg-preview-1773261779990.png"
            alt={`${appName} Logo`}
            width={96}
            height={96}
            className="object-contain"
            priority
          />
        </div>

        <div>
          <h1 className="font-heading text-4xl md:text-5xl uppercase tracking-widest leading-none">
            {renderAppName(appName)}
          </h1>
          <div className="flex items-center justify-center gap-2 mt-2">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-primary/50" />
            <p className="font-mono text-xs text-muted-foreground uppercase tracking-[0.3em] px-2">
              GEHEIME ORTE für Entdecker ❌
            </p>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-primary/50" />
          </div>
        </div>
      </div>

      {/* Tagline */}
      <p className="font-body text-muted-foreground text-sm max-w-xs mx-auto leading-relaxed">
        Exklusives Netzwerk für urbane Entdecker. Zugang nur über Instagram-Community.
      </p>
    </div>
  );
}